var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_9323",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 9323",
    transform: "translate(11129 10330)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3991",
    "data-name": "\\u9577\\u65B9\\u5F62 3991",
    width: 32,
    height: 32,
    transform: "translate(-11129 -10330)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-11123.001 -10324.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1559",
    "data-name": "\\u30D1\\u30B9 1559",
    d: "M15.973,17.979l-7.45,7.45a1.443,1.443,0,0,1-1.064.418A1.506,1.506,0,0,1,6.394,23.3l7.45-7.45L6.392,8.4a1.442,1.442,0,0,1-.418-1.064A1.431,1.431,0,0,1,7.456,5.85a1.442,1.442,0,0,1,1.065.418l7.45,7.452,7.45-7.452a1.483,1.483,0,0,1,2.55,1.064A1.442,1.442,0,0,1,25.552,8.4L18.1,15.85l7.45,7.45a1.506,1.506,0,1,1-2.13,2.13Z",
    transform: "translate(-5.972 -5.815)",
    fill: "#4ea9cd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsClose);
export default __webpack_public_path__ + "static/media/icons_close.d6ffcee10ef8d8bbadbc0e12ad0964a5.svg";
export { ForwardRef as ReactComponent };